import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IUserForm } from '../../interfaces/user-form';
import { BBWTMessageService } from '../../services';
import { UserService } from '../../services';

@Component({
  templateUrl: 'user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
  public orgType: number;
  public userForm: UntypedFormGroup;
  public user: IUserForm;
  public userId: string;
  constructor(
    private userService: UserService,
    private router: Router,
    public messageService: BBWTMessageService,
  ) {}

  ngOnInit() {
    this.userService.getCurrentUserOrg().then((res) => {
      console.log(res);
      this.orgType = res != null ? (this.orgType = res.organisationTypeId) : 0;
    });

    this.user = {
      id: new UntypedFormControl(
        0,
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      userName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(100), NoEmptyString]),
      ),
      email: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      firstName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      lastName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      phoneNumber: new UntypedFormControl('', null),
    };

    this.userForm = new UntypedFormGroup({
      userName: this.user.userName,
      email: this.user.email,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      phoneNumber: this.user.phoneNumber,
    });

    this.getCurrentUser();
  }

  getCurrentUser() {
    this.userService.getLoggedUser().then((res) => {
      this.userId = res.id;
      console.log(res);
      this.userForm.patchValue({
        id: this.userId,
        userName: res.userName,
        email: res.email,
        firstName: res.firstName,
        lastName: res.lastName,
        phoneNumber: res.phoneNumber,
      });
    });
  }

  save(formValues) {
    formValues.id = this.userId;
    console.log(formValues);
    this.userService.saveProfile(formValues).then((res) => {
      this.goToUsersList();
    });
  }

  goToUsersList() {
    if (this.orgType == 1) this.router.navigate(['app/vmeusers']);
    else if (this.orgType == 2) this.router.navigate(['app/customerusers']);
    else if (this.orgType == 3) this.router.navigate(['app/supplierusers']);
  }
}
